import statistical from './statistical'
import activity from './activity'

export default{
    statistical,
    activity
}


// WEBPACK FOOTER //
// ./src/api/apis/pam/index.js